export enum TipoAutorizacionEnum {
  AAM = 1,
  ABM = 2,
  ACM = 3,
  ADM = 4,
  AEM = 5,
  ACV = 6,
  AFM = 7,
  PUENTES = 8,
}
